export const logout = {
    success: {
        title: '로그아웃 성공',
        message: '정상적으로 로그아웃 되었습니다.',
    },
    error: {
        title: '로그아웃 실패',
        fail: '정상적인 로그아웃 처리가 이뤄지지 못했습니다. (fail)',
        withLogin: '비정상적으로 작동되었습니다. 페이지를 갱신시켜주세요.'
    },
};


export const login = {
    rule: {
        email: {
            required: '이메일을 입력해주세요.',
        },
        password: {
            required: '패스워드를 입력해주세요.',
        },
    },
    error: {
        fail: '정상적으로 로그인 되지 않았습니다.',
        title: '로그인 실패',
        notRegistered: '계정이 등록되어 있지 않습니다.',
        notMatched: '패스워드를 확인해주세요.',
        invalidInput: '이메일과 패스워드의 형식을 맞춰주세요',
    },
};

export const refresh = {
    error: {
        title: '로그인 유지 실패',
        fail: '정상적으로 갱신이 이뤄지지 못했습니다',
        httpRefresh: '갱신 기간이 만료되었습니다.\n다시 로그인해주세요.',
    },
};

export const checkUserInfo = {
    error: {
        title: '유저 정보 미적용',
        fail: '트레이딩 웍스를 통해 유저 정보를 적용시켜주세요.',
        setFailTitle: '유저 정보 적용 실패',
        setFail: '페이지가 정상 동작 하고 있지 않습니다.\n페이지를 새로고침해주세요.',
        readFailTitle: '유저 정보 읽기 실패',
        readFail: '예기치 않은 이유로 유저 정보를 읽어오지 못했습니다.\n다시 시도해주세요.\n(에러가 반복될 경우, 신속한 대응을 위해 문의를 부탁드립니다.)',
    }
}

export const checkApiTokenHeader = {
    error :{
        title: '인증 헤더 에러',
        fail: '인증 헤더 정보 지정에 실패했습니다.\n다시 로그인해주세요.',
    }
}